<template>
  <div>
    <validation-observer ref="form">
      <form novalidate @submit.prevent="savePerformace" class="h-100">
        <mdb-modal side position="right" size="lg" fullHeight direction="right" :show="modal" @close="close">
            <mdb-modal-header>
                <mdb-modal-title class="h4">Leistungsnachweis erstellen</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body class="example-card scrollbar-blue thin">
                <mdb-stepper
                  v-model="currentStep"
                  simpleH
                  :steps="steps"
                  class="p-0 m-0"
                >
                    <template #1>
                        <mdb-tab tabs card color="primary" justify>
                            <mdb-tab-item :active="tabActive==0" @click.native.prevent="tabActive=0">Grundpflege</mdb-tab-item>
                            <mdb-tab-item :active="tabActive==1" @click.native.prevent="tabActive=1">Behandlungspflege</mdb-tab-item>
                            <mdb-tab-item :active="tabActive==2" @click.native.prevent="tabActive=2">Pflegeplanung</mdb-tab-item>
                        </mdb-tab>

                        <mdb-tab-content class="border border-1 border-light rounded example-card scrollbar-blue thin">
                            <mdb-tab-pane class="fade scrollbar" key="show1" v-if="tabActive==0">
                              <mdb-accordion table class="mx-2 mt-2">
                                  <mdb-accordion-pane
                                      v-for="(gf, index) in grundpflege"
                                      :key="index"
                                      class="d-flex mb-2"
                                      title=""
                                      type="table"
                                      :isOpen="openPaneNum==index"
                                      @pane-clicked="handlePaneOpened(index)"
                                  >
                                      <span class="float-left" slot="title"> {{ gf.key }} </span>
                                      <div class="p-2 mb-1 mx-3">
                                          <mdb-input
                                            v-for="val in gf.value"
                                            :key="val.Id"
                                            v-model="val.isCheck"
                                            type="checkbox"
                                            :id="'checkbox'+val.Id"
                                            :name="'check'+val.Id"
                                            :label="val.Text"
                                            class="mb-2"
                                            @change="handleCheckboxChange($event, gf.key, val, 'grundpflege')"
                                          />
                                      </div>
                                  </mdb-accordion-pane>
                              </mdb-accordion>
                            </mdb-tab-pane>
                            <mdb-tab-pane class="fade scrollbar" key="show2" v-if="tabActive==1">
                              <mdb-accordion table class="mx-2 my-2">
                                  <mdb-accordion-pane
                                      v-for="(bh, index) in behandlungspflege"
                                      :key="index"
                                      class="d-flex"
                                      title=""
                                      type="table"
                                      :isOpen="openPaneNum==index"
                                      @pane-clicked="handlePaneOpened(index)"
                                  >
                                      <span class="float-left" slot="title"> {{ bh.key }} </span>
                                      <div class="p-2 mb-1 mx-3">
                                          <mdb-input
                                            v-for="val in bh.value"
                                            :key="val.Id"
                                            v-model="val.isCheck"
                                            type="checkbox"
                                            :id="'checkbox'+val.Id"
                                            :name="'check'+val.Id"
                                            :label="val.Text"
                                            class="mb-2"
                                            @change="handleCheckboxChange($event, bh.key, val, 'behandlungspflege')"
                                          />
                                      </div>
                                  </mdb-accordion-pane>
                              </mdb-accordion>
                            </mdb-tab-pane>
                            <mdb-tab-pane class="fade scrollbar" key="show3" v-if="tabActive==2">
                              <mdb-accordion table class="mx-2 my-2">
                                  <mdb-accordion-pane
                                      v-for="(pf, index) in pflegeplanung"
                                      :key="index"
                                      class="d-flex"
                                      title=""
                                      type="table"
                                      :isOpen="openPaneNum==index"
                                      @pane-clicked="handlePaneOpened(index)"
                                  >
                                      <span class="float-left" slot="title"> {{ pf.key }} </span>
                                      <div class="p-2 mb mx-3">
                                          <mdb-input
                                            v-for="val in pf.value"
                                            :key="val.Id"
                                            v-model="val.isCheck"
                                            type="checkbox"
                                            :id="'checkbox'+val.Id"
                                            :name="'check'+val.Id"
                                            :label="val.Text"
                                            class="mb-2"
                                            @change="handleCheckboxChange($event, pf.key, val, 'pflegeplanung')"
                                          />
                                      </div>
                                  </mdb-accordion-pane>
                              </mdb-accordion>
                            </mdb-tab-pane>
                        </mdb-tab-content>
                    </template>
                    <template #2>
                      <div class="mx-5 mb-5">
                        <mdb-row>
                          <mdb-col sm="6">
                          <validation-provider
                            name="Datum"
                            rules="required"
                            v-slot="{ errors, valid, validated }"
                            slim
                            >
                            <mdb-date-picker
                              v-model="datum"
                              disabledFuture
                              label="Datum"
                              name="Datum"
                              :option="optionDatePicker"
                              :customValidation="validated"
                              :isValid="valid"
                              :invalidFeedback="errors[0]"
                              validFeedback="sieht gut aus"
                              outline
                              @getValue="getPickersValue"
                            />
                          </validation-provider>
                          </mdb-col>
                        </mdb-row>
                        <span class="font-weight-bold">Kommentar</span>
                        <p v-if="kommentError!==''" class="red-text"> {{ kommentError }}</p>
                        <div
                          v-for="val in grundpflegeNames"
                          :key="val.key"
                        >
                          <validation-provider
                            :name="val.Text"
                            rules=""
                            v-slot="{ errors, valid, validated }"
                            slim
                            >
                            <mdb-input
                                v-model="val.Kommentar"
                                type="textarea"
                                :rows="2"
                                :label="val.Text"
                                :name="val.Text"
                                :customValidation="validated"
                                :isValid="valid"
                                :invalidFeedback="errors[0]"
                                validFeedback="sieht gut aus"
                                outline
                                class="mt-0"
                            />
                            </validation-provider>
                        </div>
                        <div
                          v-for="val in behandlungspflegeNames"
                          :key="val.key"
                        >
                          <validation-provider
                            :name="val.Text"
                            rules=""
                            v-slot="{ errors, valid, validated }"
                            slim
                            >
                            <mdb-input
                                v-model="val.Kommentar"
                                type="textarea"
                                :rows="2"
                                :label="val.Text"
                                :name="val.Text"
                                :customValidation="validated"
                                :isValid="valid"
                                :invalidFeedback="errors[0]"
                                validFeedback="sieht gut aus"
                                outline
                            />
                            </validation-provider>
                        </div>
                        <div
                          v-for="val in pflegeplanungNames"
                          :key="val.key"
                        >
                          <validation-provider
                            :name="val.Text"
                            rules=""
                            v-slot="{ errors, valid, validated }"
                            slim
                            >
                            <mdb-input
                                v-model="val.Kommentar"
                                type="textarea"
                                :rows="2"
                                :label="val.Text"
                                :name="val.Text"
                                :customValidation="validated"
                                :isValid="valid"
                                :invalidFeedback="errors[0]"
                                validFeedback="sieht gut aus"
                                outline
                            />
                            </validation-provider>
                        </div>
                      </div>
                    </template>
                </mdb-stepper>
            </mdb-modal-body>
            <mdb-modal-footer>
                <mdb-btn
                  v-if="currentStep==1"
                  color="grey lighten-1"
                  @click.native="close"
                >
                  Zurück
                </mdb-btn>
                <mdb-btn
                  v-else
                  color="grey lighten-1"
                  @click.native="stepChange"
                >
                  Zurück
                </mdb-btn>

                <mdb-btn
                  v-if="currentStep==1"
                  color="primary"
                  @click.native="stepChange"
                >
                  Weiter <mdb-icon icon="angle-right" />
                </mdb-btn>
                <mdb-btn
                  v-else
                  color="primary"
                  :disabled="loading"
                  type="submit"
                >
                  <template v-if="!loading">
                    Erstellen <mdb-icon icon="save" />
                  </template>
                  <template v-else>
                    <span
                      class="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Verladung
                  </template>
                </mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import utils from '@/mixins/Utils'
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbDatePicker,
    mdbInput,
    mdbIcon,
    mdbTab,
    mdbTabItem,
    mdbTabContent,
    mdbTabPane,
    mdbStepper,
    mdbAccordion,
    mdbAccordionPane,
    mdbRow,
    mdbCol
  } from 'mdbvue';

  export default {
    name: 'AddPerformanceModal',
    mixins: [utils()],
    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbDatePicker,
      mdbInput,
      mdbIcon,
      mdbTab,
      mdbTabItem,
      mdbTabContent,
      mdbTabPane,
      mdbStepper,
      mdbAccordion,
      mdbAccordionPane,
      mdbRow,
      mdbCol
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        modal: false,
        loading: false,
        datum: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        form: {
          Datum: '',
          GastId: '',
          AenderungAm: '',
          AenderungVon: '',
          LeistungsnachweisZuordnung: [],
        },
        defaultForm: {
          Datum: '',
          GastId: '',
          AenderungAm: '',
          AenderungVon: '',
          LeistungsnachweisZuordnung: [],
        },
        tabActive: 0,
        openPaneNum: null,
        currentStep: 1,
        grundpflege: [],
        behandlungspflege: [],
        pflegeplanung: [],
        grundpflegeNames: [],
        behandlungspflegeNames: [],
        pflegeplanungNames: [],
        steps: [
          { name: "Leistung" },
          { name: "Kommentar" }
        ],
        GrundpflegeKey: 1,
        BehandlungspflegeKey: 2,
        PflegeplanungKey: 3,
        kommentError: ''
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    created() {
      this.loadGrundpflegeOptions()
      this.loadBehandlungspflegeOptions()
      this.loadPflegeplanungOptions()
    },

    methods: {
      close () {
        this.$refs.form.reset()
        this.datum = new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes(),
        this.form = Object.assign({}, this.defaultForm)
        this.grundpflegeNames = [],
        this.behandlungspflegeNames = [],
        this.pflegeplanungNames = [],
        this.openPaneNum = null
        this.currentStep = 1

        if (this.grundpflege.length > 0) {
          this.grundpflege.forEach(element => {
            for (let index = 0; index < element.value.length; index++) {
              if (element.value[index].isCheck !== undefined) {
                delete element.value[index].isCheck
              }
            }
          })
        }

        if (this.behandlungspflege.length > 0) {
          this.behandlungspflege.forEach(element => {
            for (let index = 0; index < element.value.length; index++) {
              if (element.value[index].isCheck !== undefined) {
                delete element.value[index].isCheck
              }
            }
          })
        }

        if (this.pflegeplanung.length > 0) {
          this.pflegeplanung.forEach(element => {
            for (let index = 0; index < element.value.length; index++) {
              if (element.value[index].isCheck !== undefined) {
                delete element.value[index].isCheck
              }
            }
          })
        }

        this.$emit('close')
      },

      save () {
        this.close()
        this.$emit('save')
      },

      getPickersValue (value) {
        if(value) {
          this.datum = value
        }
      },

      handlePaneOpened(num) {
        if (this.openPaneNum == num) {
            return (this.openPaneNum = null)
        }
        this.openPaneNum = num;
      },

      stepChange () {
        this.currentStep == 1 ? this.currentStep = 2 : this.currentStep = 1
      },

      loadGrundpflegeOptions () {
        this.$http.get(`/Leistungsnachweis/Art/${this.roomID}/${this.GrundpflegeKey}`)
          .then(res => {
            if(res.data) {
                let data = res.data.data
                let list = []
                let mainKey = data[0].Gruppierung
                let elementValue = []
                let element
                let isSingleKey = true
                data.map(function(art) {
                  if(art.Gruppierung == mainKey) {
                    elementValue.push(art)
                  }else {
                    element = { key: mainKey, value: elementValue }
                    list.push(element)

                    elementValue = []
                    mainKey = art.Gruppierung
                    elementValue.push(art)
                    isSingleKey = false
                  }
                })
                if(isSingleKey || data[data.length - 1]) {
                  element = { key: mainKey, value: elementValue }
                  list.push(element)
                }
                this.grundpflege = list
            }else {
                this.$notify.error({message: 'Proof of Performance Art Request konnte nicht erhalten werden', position: 'top right', closeButton: false, timeOut: 5000})
            }
          })
          .catch((error) => {
            this.$notify.error({message: error.response.data.ResponseStatus.Message, position: 'top right', closeButton: false, timeOut: 5000})
          })
      },

      loadBehandlungspflegeOptions () {
        // Behandlungspflege
        this.$http.get(`/Leistungsnachweis/Art/${this.roomID}/${this.BehandlungspflegeKey}`)
        .then(res => {
          if(res.data) {
              let data = res.data.data
              let list = []
              let mainKey = data[0].Gruppierung
              let elementValue = []
              let element
              let isSingleKey = true
              data.map(function(art) {
                if(art.Gruppierung == mainKey) {
                    elementValue.push(art)
                }else {
                    element = { key: mainKey, value: elementValue }
                    list.push(element)

                    elementValue = []
                    mainKey = art.Gruppierung
                    elementValue.push(art)
                    isSingleKey = false
                }
              })
              if(isSingleKey || data[data.length - 1]) {
                element = { key: mainKey, value: elementValue }
                list.push(element)
              }
              this.behandlungspflege = list
          }else {
            this.$notify.error({message: 'Proof of Performance Art Request konnte nicht erhalten werden', position: 'top right', closeButton: false, timeOut: 5000})
          }
        })
        .catch((error) => {
          this.$notify.error({message: error.response.data.ResponseStatus.Message, position: 'top right', closeButton: false, timeOut: 5000})
        })
      },

      loadPflegeplanungOptions () {
        // Pflegeplanung
        this.$http.get(`/Leistungsnachweis/Art/${this.roomID}/${this.PflegeplanungKey}`)
        .then(res => {
          if(res.data) {
              let data = res.data.data
              let list = []
              let mainKey = data[0].Gruppierung
              let elementValue = []
              let element
              let isSingleKey = true
              data.map(function(art) {
                if(art.Gruppierung === mainKey) {
                    elementValue.push(art)
                }else {
                    element = { key: mainKey, value: elementValue }
                    list.push(element)

                    elementValue = []
                    mainKey = art.Gruppierung
                    elementValue.push(art)
                    isSingleKey = false
                }
              })
              if(isSingleKey || data[data.length - 1]) {
                element = { key: mainKey, value: elementValue }
                list.push(element)
              }
              this.pflegeplanung = list
          }else {
            this.$notify.error({message: 'Proof of Performance Art Request konnte nicht erhalten werden', position: 'top right', closeButton: false, timeOut: 5000})
          }
        })
        .catch((error) => {
          this.$notify.error({message: error.response.data.ResponseStatus.Message, position: 'top right', closeButton: false, timeOut: 5000})
        })
      },

      savePerformace() {
        if (this.currentStep === 2) {
          this.currentStep += 1
          return
        }

        if(this.grundpflegeNames.length <= 0 && this.behandlungspflegeNames.length <= 0 &&
          this.pflegeplanungNames.length <= 0 )
        {
          this.kommentError = 'Bitte wählen Sie einen Leistungsnachweis aus'
          return
        }

        //set data
        this.form.Datum = this.formatDateY(this.datum)
        var userDate= new Date(this.form.Datum+ ' ' +this.uhrzeit)
        this.form.Datum = this.serverDateFormat(userDate)
        this.form.AenderungAm =  this.serverDateFormat(userDate)
        this.form.AenderungVon = this.loginUser.username
        this.form.GastId = this.roomID

        this.form.LeistungsnachweisZuordnung = [...this.grundpflegeNames, ...this.behandlungspflegeNames,
             ...this.pflegeplanungNames]

        this.loading = true
        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
          }

          this.$http.post('/Leistungsnachweis', this.form)
            .then(res => {
              if(res.data) {
                  this.$notify.success({message: 'Leistungsnachweis erfolgreich erstellen', position: 'top right', closeButton: false, timeOut: 5000})
                  this.save()
              }else {
                  this.$notify.error({message: 'Gescheitert!! Leistungsnachweis erstellen', position: 'top right', closeButton: false, timeOut: 5000})
              }
            })
            .catch((error) => {
              this.$notify.error({message: error.response.data.ResponseStatus.Message, position: 'top right', closeButton: false, timeOut: 5000})
            })
            .finally(() => {
              this.loading = false
            })
        });
      },

      handleCheckboxChange(event, mainKey, data, type) {
        if(event) {
          if(type == 'grundpflege')
          {
            let index = this.grundpflege.findIndex(item => item.key == mainKey )
            let valIndex = this.grundpflege[index].value.findIndex(item => item.Id == data.Id )

            this.grundpflege[index].value[valIndex].isCheck = event
            this.grundpflegeNames.push({'Leistung': data.Id, 'FreieLeistung': data.Text, 'Text': data.Text, 'Pflegeplanung': data.Pflegeplanung})
          }

          if(type == 'behandlungspflege') {
            let index = this.behandlungspflege.findIndex(item => item.key == mainKey )
            let valIndex = this.behandlungspflege[index].value.findIndex(item => item.Id == data.Id )

            this.behandlungspflege[index].value[valIndex].isCheck = event
            this.behandlungspflegeNames.push({'Leistung': data.Id, 'FreieLeistung': data.Text, 'Text': data.Text, 'Pflegeplanung': data.Pflegeplanung})
          }

          if(type == 'pflegeplanung') {
            let index = this.pflegeplanung.findIndex(item => item.key == mainKey )
            let valIndex = this.pflegeplanung[index].value.findIndex(item => item.Id == data.Id )

            this.pflegeplanung[index].value[valIndex].isCheck = event
            this.pflegeplanungNames.push({'Leistung': data.Id, 'FreieLeistung': data.Text, 'Text': data.Text, 'Pflegeplanung': data.Pflegeplanung})
          }
        }else {
          if(type == 'grundpflege') {
            let index = this.grundpflege.findIndex(item => item.key == mainKey )
            let valIndex = this.grundpflege[index].value.findIndex(item => item.Id == data.Id )

            this.grundpflege[index].value[valIndex].isCheck = event
            this.grundpflegeNames.splice(this.grundpflegeNames.indexOf(data.Id), 1);
          }

          if(type == 'behandlungspflege') {
            let index = this.behandlungspflege.findIndex(item => item.key == mainKey )
            let valIndex = this.behandlungspflege[index].value.findIndex(item => item.Id == data.Id )

            this.behandlungspflege[index].value[valIndex].isCheck = event
            this.behandlungspflegeNames.splice(this.behandlungspflegeNames.indexOf(data.Id), 1);
          }

          if(type == 'pflegeplanung') {
            let index = this.pflegeplanung.findIndex(item => item.key == mainKey )
            let valIndex = this.pflegeplanung[index].value.findIndex(item => item.Id == data.Id )

            this.pflegeplanung[index].value[valIndex].isCheck = event
            this.pflegeplanungNames.splice(this.pflegeplanungNames.indexOf(data.Id), 1);
          }
        }
      }
    }
  }
</script>
<style scoped>
  .pb-5, .py-5 {
    padding-bottom: 0px !important;
  }
</style>
